module.exports = {
  BASE_URL: 'https://tlg-api.infynno.com/',
  APP_TITLE: 'Title Generator',
}
